import type { Locale } from '@/i18n/locales';
import type { GameId, SlotId } from '@tg/shared';
import { gamePathOf } from '@tg/shared';

/** URL helpers — every page lives under /:lang. */
export const paths = {
  lobby: (l: Locale) => `/${l}`,
  signIn: (l: Locale) => `/${l}/signin`,
  signUp: (l: Locale) => `/${l}/signup`,
  /** the link from the e-mail confirmation letter (built by the server: /<lang>/verify?token=…) */
  verifyEmail: (l: Locale) => `/${l}/verify`,
  profile: (l: Locale) => `/${l}/profile`,
  /** Game Passport: a stamp per game (profile section, own page) */
  passport: (l: Locale) => `/${l}/passport`,
  fair: (l: Locale) => `/${l}/fair`,
  responsible: (l: Locale) => `/${l}/responsible`,
  tournaments: (l: Locale) => `/${l}/tournaments`,
  /** a table tournament («Турниры за столами») */
  tourney: (l: Locale, id: string) => `/${l}/tournaments/t/${encodeURIComponent(id)}`,
  /** the own table of a table tournament: the game page (it resumes the seat; `table` is informational) */
  tourneyTable: (l: Locale, g: GameId, tableId: string): string => `${paths.game(l, g)}?table=${encodeURIComponent(tableId)}`,
  friends: (l: Locale) => `/${l}/friends`,
  /** «Messages»: the conversations (its own menu item; the old `friends?tab=chat` redirects here) */
  messages: (l: Locale) => `/${l}/messages`,
  /** an open conversation (phone: full screen); analytics counts it as /messages/:id */
  chat: (l: Locale, publicId: number) => `/${l}/messages/${publicId}`,
  /** public page of a shared award (achievement or moment) */
  award: (l: Locale, id: string) => `/${l}/a/${encodeURIComponent(id)}`,
  /** invite landing */
  invite: (l: Locale, code: string) => `/${l}/i/${encodeURIComponent(code)}`,
  admin: (l: Locale) => `/${l}/admin`,
  /** privacy notice (public, linked from the footer) */
  privacy: (l: Locale) => `/${l}/privacy`,
  cookies: (l: Locale) => `/${l}/cookies`,
  /** /:lang/slots/<slot>, /:lang/puzzles/<puzzle>, /:lang/strategy/chess, /:lang/<original> (@tg/shared gamePathOf) */
  game: (l: Locale, g: GameId) => `/${l}${gamePathOf(g)}`,
  slot: (l: Locale, g: SlotId) => `/${l}/slots/${g}`,
};
